import { EuiComboBox, EuiFlexGroup, EuiFormRow } from "@elastic/eui";
import styled from "styled-components";

export const AbstractTableWrapper = styled.div`
    .euiTable {
        background-color: transparent;
    }
`;

export const TableHeaderWrapper = styled(EuiFlexGroup)`
    svg {
        width: 30px;
        height: 30px;
        fill: ${(props) => props.theme.default.euiColorFullShade};
    }
`;

export const StyledAbstractDropdown = styled(EuiComboBox)`
    min-width: 150px;
`;

export const AbstractFileFormRow = styled.div`
    position: relative;

    .asbtract-file__preview {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        pointer-events: none;
        text-align: center;
    }

    .files-thumbnail {
        margin-top: 10px;
    }

    .euiFilePicker__icon,
    .euiFilePicker__promptText,
    .euiFilePicker__clearButton {
        display: none;
    }
`;

export const AbstractFileWrapper = styled.div`
    .abstract-file__thumbnail-wrapper {
        margin-bottom: 10px;
    }
`;

export const AbstractDateFormRow = styled(EuiFormRow)`
    // Override Eui hiding time input on small scrrens
    @media only screen and (max-width: 767px) and (min-width: 575px) {
        .react-datepicker__time-container {
            display: flex;
        }
    }

    @media only screen and (max-width: 574px) {
        .react-datepicker__time-container {
            display: flex;
        }
    }
`;
